import { render, staticRenderFns } from "./canlendar-head.vue?vue&type=template&id=0cffb5ca"
import script from "./canlendar-head.vue?vue&type=script&lang=js"
export * from "./canlendar-head.vue?vue&type=script&lang=js"
import style0 from "./canlendar-head.vue?vue&type=style&index=0&id=0cffb5ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__coffee-script@_nvev6wbrwofx6itvk2x4sio6cy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports